import Vue from "vue";
import vConsole  from 'vconsole';
import UAParser from "ua-parser-js"
import VueI18n from "vue-i18n";
import { ingame, dataURLtoFile, getSys, download, isMobile } from '@tencent/pa-cms-utils';
import html2canvas from 'html2canvas';
import Aegis from 'aegis-web-sdk';

import { getRoleInfo, getSavedRoleInfo, saveRoleInfo, RoleInfo, getVoteNumber, roleVote, joinTeam, Vote } from "@/api/modules/page";
import { IsTest, getErrMessage, getLang, switchLang, isInIntlBrowser, getSpecialBrowserType } from "@/utils/tools";
import { initServetime } from "@/api";
import { reportTlog } from "@/api/modules/report";
import { fb_app_id, REGISTER_URL, ProdServerMap, isHtm } from "@/utils/const";
import { dynamicShare, share } from "@/utils/share";
import Login, { thirdLogin, liPassLogin, INTL_THIRD_TYPE, checkLogin } from "@/utils/login";
import './style.css'
import { setLanguageDialog, languageArr } from './utils/setLanguage'

Vue.use(VueI18n)
Vue.config.productionTip = false;
if (IsTest) {
  new vConsole();
}
new Aegis({
  id: 'e7eyZFle3gVwELzl6E', // 上报 id
  uin: Login.info()?.openid, // 用户唯一 ID（可选）
  reportApiSpeed: true, // 接口测速
  reportAssetSpeed: true, // 静态资源测速
  spa: true, // spa 应用页面跳转的时候开启 pv 计算
  hostUrl: 'https://rumt-sg.com',
  env: IsTest ? "test" : "production",
  api: {
    apiDetail: true,
  },
});
reportTlog({
  action: "skin_vote_home_page",
  sub_action: "cm_vshow"
})

const DEFAULT_LANG = "en";

const CMSLanguage = {
  en : 'en',
  th : 'th',
  fr : 'fr',
  de : 'de',
  pt : 'pt-all',
  es : 'es',
  id : 'id',
  ja : 'ja',
  ko : 'ko',
}
const changeFileName: { [key: string]: string } = {
  en: 'en',
  ja: 'ja',
  kr: 'ko',
  zh: 'cn'
}
// 语言路径
const allLanguageContext= require.context('./locales', false, /\**\.js$/);
const locales = allLanguageContext.keys().reduce((pre, fileName) => {
  const componentConfig = allLanguageContext(fileName)
  const name = fileName.replace(".js", "").replace("./", "");
  return {
    ...pre,
    [changeFileName[name]]: componentConfig.default,
  }
}, {})

export const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
  fallbackLocale: DEFAULT_LANG,
});
const LOCALE_KEY = "localeLanguage";

const getLangFromStorage = () => {
  const storeLang = window.localStorage.getItem(LOCALE_KEY);
  if (!storeLang) return;
  const lang = locales[storeLang as keyof typeof locales]
  if (lang === undefined) return;
  return storeLang;
}
export const setLocal = (language?: string|null) => {
  console.log("setLocal", language);
  let lang = language;
  if (lang === undefined || lang === null) {
    lang = getLangFromStorage();
  }
  if (!lang) return;
  window.localStorage.setItem(LOCALE_KEY, lang);
  i18n.locale = lang;
  // 静态Html 数据动态显示
  document.title = i18n.t("title") as string;
  window.$('body').removeClass();
  language !== 'en' && window.$('body').addClass(`lang_${lang}`);
  // const metas = document.getElementsByTagName("meta");
  // console.log('metas', metas)
  // const keywords = metas["keywords"];
  // const description = metas["description"];
  // if (keywords) {
  //   keywords.setAttribute("content", i18n.t("page.298"));
  // }
  // if (description) {
  //   description.setAttribute("content", i18n.t("page.299"));
  // }
};
const getDefaultLang = () => {
  const urlData = new URL(window.location.href);
  let urlLangType = urlData.searchParams.get("lang_type") || navigator.language || (navigator as any).userLanguage;
  switch (urlLangType) {
    case 'zh-CN':
    case 'zh-SG':
    case 'zh-TW':
    case 'zh-HK':
    case 'zh-MO':
      urlLangType = 'cn'
  }
  return urlLangType;
}
const social_map = {
  en: ['twitter', 'facebook'],
  ja: ['twitter', 'line'],
  ko: ['twitter'],
  cn: ['facebook', 'line'],
};
const urlLangType = getLang();
window.setLocal = setLocal;
setLocal(urlLangType);
const init = Vue.prototype._init;
Vue.prototype._init = function (options: any) {
  init.call(this, {
    i18n,
    ...options,
  });
};

// https://1024tools.com/timestamp utc+9
const startTimestamp= 1688007600;
const endTimestap= 1688569199; // 2023-07-05 23:59:59
const sortedTimestap= 1688634000; // 2023-07-06 18:00:00
// TODO test
// const endTimestap= 1688104800; // 2023-06-30 15:00:00
// const sortedTimestap= 1688104800;// 2023-06-30 15:00:00

new Vue<any>({
  el: "#app",
  data() {
    return {
      languageArr,
      language: urlLangType,
      email: undefined,
      password: undefined,

      roleId: 0,
      areaId: 0,

      roleList: [],
      login: checkLogin(),
      serverList: ProdServerMap,

      loading: false,
      choosed: false,
      votePlan: undefined,
      pageVotes: [
        { num: 0, tag_id: '1' },
        { num: 0, tag_id: '2' },
        { num: 0, tag_id: '3' },
      ],
      isShare: false,
      isInIntlBrowser,
      isHtm,

      voteList: [],
      showMask: false,
      voteClassMap: ['', 'plana', 'planb', 'planc'],
    }
  },
  computed: {
    languageText(){
      const lang = languageArr.find(lang =>lang.value === this.language)
      if (!lang) {
        const english = languageArr.find(lang =>lang.value === 'en')
        return english?.label
      }
      return lang.label;
    },
    roleName() {
      if (!this.roleId) return '';
      const role = this.roleList.find((role: RoleInfo) => role.role_id === this.roleId);
      if (!role) return '';
      return role.role_name;
    },
    leftShareChannle(){
      const target = social_map[getLang()];
      const channels = [...target];
      channels.splice(0,1);
      return channels
    },
    shareImg() {
      const vote = ['a', 'b', 'c'][this.votePlan|| 0];
      const langMap = {
        en: "en",
        ko: "ko",
        cn: "zh",
        ja: "ja",
      }
      const lang = langMap[this.language as keyof typeof langMap];
      return `ossweb-img/share_${lang}_${vote}.jpg`
    },
    shareStyle() {
      if (this.language === 'en' || this.language === 'ja' || this.language === 'ko') return {}
      const target = social_map[getLang()];
      const [main] = target;
      const textMap = {
        facebook: "fb",
        kakao: "tk",
      }
      const langMap = {
        ko: "ko",
        cn: "zh",
      }
      const text = textMap[main as keyof typeof textMap];
      const lang = langMap[this.language as keyof typeof langMap];
      const img = `ossweb-img/${lang}/share_p_${text}_btn_${lang}.png`;
      return {
        backgroundImage: `url(${img})`,
      }
    },
    sortedVotes() {
      if (!this.pageVotes) return [
        { num: 0, tag_id: '1' },
        { num: 0, tag_id: '2' },
        { num: 0, tag_id: '3' },
      ];
      if (window.serverTime < sortedTimestap) return this.pageVotes
      // https://1024tools.com/timestamp 2023-07-06 18:00:00
      if (window.serverTime >= sortedTimestap) {
        const sorted = (this.pageVotes as Vote[]).sort((a, b) =>  b.num - a.num)
        return sorted
      }
      return this.pageVotes;
    }
  },
  watch: {
    language: {
      handler(lang, oldLang) {
        window.setLocal(lang);
        window.$("body").addClass(`lang_${lang}`)
        window.$("body").removeClass(`lang_${oldLang}`)
      },
      immediate: true,
    },
    areaId(val) {
      if (!val || !checkLogin()) return;
      this.roleList = [];
      const role = this.areaRoleMap.get(val);
      if (role) {
        this.roleList = [role];
        return;
      }
      this.loading = true;
      getRoleInfo({area_id: val }).then((res) => {
        if (!res || res.code !== 0) return;
        const { data } = res;
        if (!data.get_role_info) return;
        const { get_role_info} = data;
        // 异步 可能 areaId已改变
        if (val !== this.areaId) {
          this.areaRoleMap.set(val, get_role_info);
          return
        }
        this.roleList = [get_role_info];
      }).finally(() => {
        this.loading = false;
      })
    },
    isShare(val) {
      if (!val) {
        window.gotoPage(0);
        // 将滚动条位置置于顶部
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        })
        this.getVoteNumber();
        return;
      }
      window.gotoPage(1);
      // 将滚动条位置置于顶部
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      })
      setTimeout(() => {
        // 存在异步图片资源未加载完
        this.dynamicShare();
      }, 200)
    },
  },
  async created(){
    this.areaRoleMap = new Map();
    await Login.init()
    this.login = checkLogin()
    await initServetime();
    await this.init();
    this.addMask();
  },
  mounted(){
    document.addEventListener('click', this.closeDialog);
  },
  methods: {
    async init() {
      // 异步获取 投票信息
      this.getVoteNumber();
      if (checkLogin()){
        // 登录了， 异步获取 绑定区服信息
        this.getSavedRoleInfo();
      }
    },
    addMask() {
      if (window.serverTime < startTimestamp || window.serverTime > endTimestap) {
        this.showMask = true;
      }
    },
    clcikMask() {
      if (window.serverTime < startTimestamp) {
        this.showMessgae(this.$t('FlowHasNotBegin'))
        return;
      }
      if (window.serverTime > endTimestap) {
        this.showMessgae(this.$t('FlowHasEnd'))
        return;
      }
      this.showMask = false;
    },
    showMessgae(text: string) {
      window.showTips(text);
    },
    setLanguageDialog,
    setLanguage(event: Event) {
      event.stopPropagation();
      const lang = window.$(event.target).attr('value');
      this.closeDialog();
      // if (IsTest) {
      //   this.language = lang
      //   return;
      // }
      // 切换语言条链接
      switchLang(lang);
    },
    closeDialog() {
      window.$('.nv_list').hide();
      window.$('.loginout_box').hide();
    },
    async register(){
      const target = `${REGISTER_URL}&redirect_url=${encodeURIComponent(
        window.location.href
      )}`;
      if (ingame.isInIntlBrowser) {
        ingame.openInBrowser(target);
      } else {
        window.open(target, '_blank');
      }
    },
    async third_login(channel: INTL_THIRD_TYPE){
      try {
        console.log('third_login', channel)
        if (getSpecialBrowserType() && isMobile()) {
          this.showMessgae(this.$t("open_in_browser"));
          return;
        }
        const res = await thirdLogin({ channel });
        this.login = true;
        this.trigerAreaSelect()
        reportTlog({
          action: "skin_vote_login_success",
          sub_action: "cm_click",
          ext_content: {
            ret: res?.ret,
            channel_name: channel,
          }
        })
      } catch(error){
        console.log('error', error)
        this.showMessgae(this.$t("third_auth_failed"));
      }
    },
    async liPassLogin(){
      if (!this.email || !this.password) {
        this.showMessgae(this.$t("pls_input_info"));
        return;
      }
      try {
        const res = await liPassLogin({ 
          email: this.email,
          password: this.password
        });
        this.login = true;
        this.trigerAreaSelect()
        reportTlog({
          action: "skin_vote_login_success",
          sub_action: "cm_click",
          ext_content: {
            ret: res?.ret,
            channel_name: 'email',
          }
        })
      } catch(error){
        const message = getErrMessage((error as Error).message as any);
        this.showMessgae(message);
      }
    },
    async submitRole(){
      if (this.loading) return;
      if (!checkLogin()) {
        this.showMessgae(this.$t("pls_input_info"))
        return;
      }
      if (!this.roleId || !this.areaId) {
        this.showMessgae(this.$t("pls_input_info"))
        return;
      }
      this.loading = true;
      try {
        const res = await saveRoleInfo({
          area_id: this.areaId,
          role_id: this.roleId,
        });
        if(res && res.code === 601009) {
          window.location.reload()
          return
        }
        if (res && res.code == 0) {
          window.closeDialog();
          this.choosed = true;
        }
      } finally {
        this.loading = false;
      }
    },
    async trigerAreaSelect(){
      if (this.choosed) {
        window.closeDialog();
        return;
      }
      await this.getSavedRoleInfo()
      if (this.choosed) {
        window.closeDialog();
        return;
      }
      this.areaId = this.serverList[0].id;
      window.TGDialogS('d7');
    },
    logout() {
      Login.logout();
      window.location.reload()
    },
    clickLogin() {
      if (!checkLogin()) {
        window.TGDialogS('d6');
        reportTlog({
          action: "skin_vote_login_page",
          sub_action: "cm_vshow"
        })
        return;
      }
      if (!this.choosed) {
        window.TGDialogS('d7');
        return;
      }
    },
    clickLogout(event: Event){
      event.stopPropagation();
      window.$('.loginout_box').show();
    },
    async clickVote(num: string) {
      if (!this.login || !this.choosed) {
        this.clickLogin()
        return;
      }
      try {
        if (this.voteList.length > 0) {
          const index = this.voteList[0].tag_id;
          this.votePlan = Number(index) - 1;
          window.closeDialog();
          this.isShare = true;
          return;
        }
        const number = Number(num) - 1;
        window.TGDialogS('d5');
        window.$('.surebox_img').eq(number).show().siblings().hide();
        window.$('.sure_imgnamebox').find('p').eq(number).show().siblings().hide();
        this.votePlan = number;
        reportTlog({
          action: "skin_vote_btn",
          sub_action: "cm_click",
          ext_content: {
            skin_id: this.votePlan + 1,
          }
        })
      } catch(error){
        console.log('clickVote', error)
      }
    },
    async confirmVote() {
      reportTlog({
        action: "skin_vote_confirm_btn",
        sub_action: "cm_click",
        ext_content: {
          skin_id: this.votePlan + 1,
        }
      })
      if (!this.login || !this.choosed) {
        this.clickLogin()
        return;
      }
      try {
        const res = await roleVote({ tag_id: String(this.votePlan + 1) });
        if (res && res.code === 0) {
          window.closeDialog();
          this.isShare = true;
          this.voteList = [{ tag_id: String(this.votePlan + 1) }]
          reportTlog({
            action: "skin_vote_success",
            sub_action: "cm_click",
            ext_content: {
              skin_id: this.votePlan,
            }
          });
        } 
      } catch (error) {
        this.showMessgae(error);
        window.closeDialog();
      }
    },
    async dynamicShare(){
      // 港澳台 不使用分享服务， 无法部署资源， 修改html查看效果
      this.isLoading = true;
      const img = await this.getBase64Image()
      this.img = img;
      const uid = `${this.language}_${this.votePlan || ''}_20230629_2`;
      // 港澳台 不使用分享服务， 无法部署资源， 修改html查看效果
      if (isHtm) {
        this.dynamicShareResult = {
          // 港澳台分享地址， 由dynamicShareResult覆盖
          share_url: "https://nikke.hotcool.tw/moderniapoll/",
        };
        this.isLoading = false
        return
      };
      try {
        const cmsLang = CMSLanguage[this.language as keyof typeof CMSLanguage];
        const result = await dynamicShare({
          file: dataURLtoFile(img, `${uid}.jpg`).file,
          uid,
          url_querys: new URLSearchParams({ language: cmsLang }),
        })
        this.dynamicShareResult = result;
        console.log('result', result)
      } catch (e){
        this.showMessgae(this.$t("serverError"))
      } finally{
        this.isLoading = false;
      }
    },
    async share(channel: string) {
      reportTlog({
        action: "skin_vote_share_channel_btn",
        sub_action: "cm_click",
        ext_content: {
          skin_id: this.votePlan,
          channel_name: channel,
        }
      })
      if (this.isLoading || !this.dynamicShareResult) {
        this.showMessgae(this.$t("laodingPic"))
        return;
      }
      const res = await joinTeam();
      if (!res || res.code !== 0) return;
      try{
        await share({
        ...this.dynamicShareResult,
        app_id: fb_app_id,
        title: this.$t("shareContent"),
        text: this.$t("shareContent"),
        hashtag: "#NIKKE",
        channel,
        });
      } catch(error) {
        console.log('share error', error)
      }
    },
    async mainShare (){
      reportTlog({
        action: "skin_vote_share_btn",
        sub_action: "cm_click",
        ext_content: {
          skin_id: this.votePlan,
        }
      })
      const target = social_map[getLang()];
      const [main] = target;
      this.share(main as any);
    },
    async getBase64Image(){
      const dom = document.querySelector('.share_imgbox img') as HTMLElement;
      if (!dom) return;
      const canvas = await html2canvas(dom, {scale: 2,logging:false,useCORS:true})
      return canvas.toDataURL("png"); // 获取生成的图片的url
    },
    downloadImage() {
      reportTlog({
        action: "skin_vote_share_download_pic",
        sub_action: "cm_click",
        ext_content: {
          skin_id: this.votePlan,
        }
      })

      const browser = getSpecialBrowserType();
      // android 无法保存图片
      if (ingame.isInIntlBrowser && getSys().name?.toLowerCase() === 'android') {
        if (this.loading || !this.dynamicShareResult) {
          this.showMessgae(this.$t('laodingPic'))
          return;
        }
        // 【安卓】繁中 游戏内点击游戏下载按钮出现闪退
        if (isHtm) {
          this.showMessgae(this.$t("open_in_browser"));
          return
        }
        ingame.openInBrowser(this.dynamicShareResult.image_url);
      } else if (['facebook', 'line'].includes(browser) && getSys().name?.toLowerCase() === 'android') {
        // 提示
        this.showMessgae(this.$t("open_in_browser"));
        return;
        // window.open(this.dynamicShareResult.image_url, '_blank');
      } else {
        if (!this.img) {
          this.showMessgae(this.$t('laodingPic'))
          return;
        }
        download({
          base64: this.img,
          filename: 'share.jpg',
        });
      }
    },
    async getSavedRoleInfo() {
      const res = await getSavedRoleInfo()
      if (!res || res.code !== 0) return;
      const { data } = res;
      if (!data.has_saved_role_info) return;
      const { has_saved_role_info, get_saved_role_info, vote_log_list = [] } = data;
      const { area_id, role_id }  = get_saved_role_info;
      this.areaId = area_id;
      this.roleId = role_id;
      this.roleList = [get_saved_role_info];
      this.choosed = has_saved_role_info;
      this.areaRoleMap.set(area_id, get_saved_role_info);
      this.voteList = vote_log_list;
    },
    getPlayNumber(number: number) {
      if (!this.pageVotes || this.pageVotes.length < 1) return 0;
      return this.pageVotes[number]?.num;
    },
    clickBack() {
      reportTlog({
        action: "skin_vote_share_reback_btn",
        sub_action: "cm_click",
      })
      this.isShare = false
    },
    clickMainVote(){
      reportTlog({
        action: "skin_vote_now_btn",
        sub_action: "cm_click",
      })
    },
    cancelArea() {
      window.closeDialog()
      Login.logout();
    },
    async getVoteNumber() {
      const res = await getVoteNumber()
      if (!res || res.code !== 0) return;
      const { data } = res;
      if (!data.vote_list) return;
      this.pageVotes = data.vote_list.team_list;
    },
    getOpenTwitterLink(e: Event) {
      e.preventDefault();
      interface LinkMap {
        [key: string]: {
          pc: string;
          mobile: string;
        };
      }
      const linkMap: LinkMap = {
        en: {
          pc: 'https://twitter.com/NIKKE_en',
          mobile: 'https://twitter.com/NIKKE_en'
        },
        ja: {
          pc: 'https://twitter.com/NIKKE_japan',
          mobile: 'https://twitter.com/NIKKE_japan'
        },
        ko: {
          pc: 'https://game.naver.com/lounge/nikke/board/11',
          mobile: 'https://m.game.naver.com/lounge/nikke/board/11'
        }
      }
      const link = linkMap[getLang()];
      if (!link) return window.open('https://twitter.com/NIKKE_en', '_blank');
      if (Login.isMobile()) return window.open(link.mobile, '_blank');
      return window.open(link.pc, '_blank');
    },
    getOpenFacebookLink(e: Event) {
      e.preventDefault();
      return window.open('https://www.facebook.com/TW.NIKKE/', '_blank');
    },
    getOpenNarLink(e: Event){
      e.preventDefault();
      return window.open('https://game.naver.com/lounge/nikke/board/11/', '_blank');
    },
    toPolicy(type: 'cookie' | 'privacy' = 'cookie') {
      const map = {
        cookie: this.$t('cookiesLink'),
        privacy: this.$t('privacyLink'),
      };
      const url = map[type]
      window.open(url, '_blank');
    }
  }
});
